import React from "react";
import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalProps as ChakraModalProps
} from "@chakra-ui/react";

interface ModalProps extends ChakraModalProps {
  title?: React.ReactNode;
  showCloseButton?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  showCloseButton = true,
  children,
  ...rest
}) => {
  return (
    <ChakraModal isCentered isOpen={isOpen} onClose={onClose} {...rest}>
      <ModalOverlay />
      <ModalContent pb={4}>
        {title && (
          <ModalHeader fontWeight="bold" color="gray.700">
            {title}
          </ModalHeader>
        )}
        {showCloseButton && <ModalCloseButton />}
        <ModalBody py={0} color="gray.700">
          {children}
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};

export default Modal;
